// PlannerKanBanItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class PlannerKanBanItem extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      count: PropTypes.number,
      type: PropTypes.oneOf(['todo', 'inprogress', 'completed']),
      isSubtask: PropTypes.bool,
      percentage: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      title: '',
      count: 0,
      type: '',
      isSubtask: false,
      percentage: 0
    }
  }

  shouldComponentUpdate (nextProps, _nextState) {
    const { title, count, type, isSubtask, percentage } = this.props
    if (
      title !== nextProps.title ||
      count !== nextProps.count ||
      type !== nextProps.type ||
      isSubtask !== nextProps.isSubtask ||
      percentage !== nextProps.percentage
    ) {
      return true
    }
    return false
  }

  render () {
    const { title, count, type, isSubtask, percentage } = this.props
    const _class = classnames('planner-kanbanitem', {
      subtask: isSubtask,
      [`planner-kanbanitem_${type}`]: type
    })

    return (
      <div className={_class}>
        {count > 0 && (
          <span className='content'>
            <div className='info'>
              <div className='count'>{count}</div>
              <div className='title'>
                <IntlMessage ident={title} />
              </div>
            </div>
          </span>
        )}
        {percentage > 0 && <span className='content' />}
      </div>
    )
  }
}

export default PlannerKanBanItem
